module.exports = __webpack_public_path__ + "static/img/image_solutions_ime_07.96a8aa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_ime_07.png
// module id = 8L9w
// module chunks = 10